<p (click)="isCollapsed = !isCollapsed" class="header-button-container">
  <span>
    {{header}} 
    <kbd *ngIf="atalho" class="ml-1 kbd-mini">{{ atalho }}</kbd>
  </span>

  <i class="icofont" [ngClass]="isCollapsed ? 'icofont-rounded-down' : 'icofont-rounded-up'"></i>
</p>

<div [@smoothCollapse]="isCollapsed ? 'collapsed' : 'opened'">
  <ng-content></ng-content>
</div>